import { render } from "./TransferTemplateDialog.vue?vue&type=template&id=24dc7b80"
import script from "./TransferTemplateDialog.vue?vue&type=script&lang=js"
export * from "./TransferTemplateDialog.vue?vue&type=script&lang=js"

import exportComponent from "/home/deployuser/prod/immivo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__